import router from './index.js';

import { getToken } from "@/utils/auth.js"

router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
        if (getToken()) { //判断本地是否存在access_token
            next();
        } else {
            next();
            // next({
            //     path: 'login'
            // })
        }
    }
    else {
        next();
    }
});